import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { uploadAPI } from '../../services/api';

export const uploadFile = createAsyncThunk('upload/file', async (formData, { rejectWithValue }) => {
  try {
    const response = await uploadAPI.upload(formData);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to upload file');
  }
});

export const fetchFiles = createAsyncThunk('upload/fetchFiles', async (params, { rejectWithValue }) => {
  try {
    const response = await uploadAPI.getFiles(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch files');
  }
});

const uploadSlice = createSlice({
  name: 'upload',
  initialState: { files: [], uploading: false, loading: false, error: null, pagination: null },
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state) => { state.uploading = true; })
      .addCase(uploadFile.fulfilled, (state, action) => { state.uploading = false; state.files.unshift(action.payload); })
      .addCase(uploadFile.rejected, (state, action) => { state.uploading = false; state.error = action.payload; })
      .addCase(fetchFiles.pending, (state) => { state.loading = true; })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.files = action.payload.data || [];
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchFiles.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { clearError } = uploadSlice.actions;
export default uploadSlice.reducer;
